import { InjectionToken } from '@angular/core';
import { TeleEngineEnvironment } from '../types/tele-engine-environment';

export const TELE_ENGINE_ENVIRONMENT = new InjectionToken<TeleEngineEnvironment>('teleEngineEnvironment');
